import { useEffect, useState } from "react";

const useScreenDimension = () => {
    const [screenDimension, setScreenDimension] = useState({ width: 0, height: 0 });
    useEffect(() => {

        const handleDimension = () => {
            setScreenDimension({ height: screen.height, width: screen.width })
        }
        window.addEventListener('resize', handleDimension);

        handleDimension();
        return () => window.removeEventListener("resize", handleDimension);
    }, [])
    return screenDimension;
}
export default useScreenDimension;